export const dataCenter = {
  dataCenterFund: "dataCenterFund",
  dataCenter_data: "dataCenter_data",
  dataCenter_data_user: "dataCenter_data_user",
  dataCenter_data_content: "dataCenter_data_content",
  dataCenter_data_order: "dataCenter_data_order",
  dataCenter_user: "dataCenter_user",
  dataCenter_content: "dataCenter_content",
  dataCenter_order: "dataCenter_order",
  dataCenter_order_export: "dataCenter_order_export"
};